import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';
import ROUTE from '@app/navigationApp/routes';
import { formatIndianCurrency } from '@app/utils/utility';
import { Info } from '@app/sharedComponents/Icons/Icons';
import { LENDER_ID } from '@app/types/regix';
import { REPAYMENT_COLLECTION_TYPE } from '@app/utils/utils';
import { useCallback } from 'react';

const LoanExpiryCard = ({creditInfo,daysToRenewal,navigation}) => {
    const {principalOutStandingAmount,actualLoanAmount,netPayable} = creditInfo;

    const title = useCallback(()=>{
      if(daysToRenewal==1 ){
        return 'Loan expiring today, 5 PM'
      } else if(daysToRenewal==2 ){
        return 'Loan will expire tomorrow, 5 PM'
      } else{
        return `Your loan will expire in ${daysToRenewal} day${daysToRenewal>1 && 's'}!`
      }
    },[daysToRenewal])

    const heading = title();
    const displayAmount = principalOutStandingAmount > 0 ? principalOutStandingAmount:actualLoanAmount;
    const isRenewalAllowed = creditInfo?.attributes?.renewalAllowed;

    const handleNavigation = useCallback(() => {
      if(isRenewalAllowed){
        navigation?.navigate(ROUTE.RENEW_LOAN,{daysToRenewal})
      }else{
        if(netPayable >0){
          navigation?.navigate(ROUTE.CONFIRM_PAYMENT_DETAILS,{isFromForeclosure:true,selectedAmount:netPayable,paymentType:REPAYMENT_COLLECTION_TYPE.FORECLOSURE})
        }else{
          navigation?.navigate(ROUTE.CONFIRM_LOAN_DETAILS)
        }
      }
    },[isRenewalAllowed,principalOutStandingAmount])

    const helperText = useCallback(()=>{
      if(principalOutStandingAmount >0){
        return 'Please clear all dues before expiry to avoid portfolio sell-off. '
      }else{
        if(isRenewalAllowed){
          return 'What happens if i do not renew? '
        }else{
          return 'You are not eligible to renew your loan account. '
        }
      }
    },[isRenewalAllowed,principalOutStandingAmount])

    const buttonLabel = useCallback(()=>{

      if(isRenewalAllowed){
        return 'Renew loan'
      }else{
        if(principalOutStandingAmount >0){
          return 'Clear dues'
        }else{
          return 'Close loan'
        }
      }
    },[isRenewalAllowed,principalOutStandingAmount])

    return(
    <ThemedView mx='lg' p='lg' mt='2xl'  borderColor='border-primary' backgroundColor='bg-surface-primary' borderWidth={1} borderRadius='lg'>
        <ThemedView flexDirection='row' mb='lg' alignItems='center'>
            <WarningCircle size={25} weight="fill" color='#DE4043'/>
        <ThemedText color='text-primary' ml='sm' variant='h5s'>
          {/* Loan expiring today, 5 PM */}
          {heading}
        </ThemedText>
        </ThemedView>

        <ThemedText color='text-secondary' mb='2xs' variant='b4r' >
          {principalOutStandingAmount >0 ?'Outstanding amount':'Credit limit'}
        </ThemedText>
        <ThemedView flexDirection='row' alignItems='center' mb='lg'>
        <ThemedText color={principalOutStandingAmount >0 ?'text-error':'text-primary'} variant='l1'>
          ₹
        </ThemedText>
        <ThemedText color={principalOutStandingAmount >0 ?'text-error':'text-primary'} variant='h1b'>
          {formatIndianCurrency(displayAmount)}
        </ThemedText>
        </ThemedView>

        <ThemedView backgroundColor='bg-fill-info' p='sm' flexDirection='row'   borderRadius='sm' mb='md'>
          <Info weight="fill" color={themeColorSet['icon-secondary']} size={16} style={{marginTop:2}}/>
          <ThemedText variant='b4m' color='text-secondary'  ml='sm' flexShrink={1}>
            {helperText()}
          {isRenewalAllowed && <ThemedText variant='b4b' onPress={()=>{navigation?.navigate(ROUTE.RENEWAL_LEARN_MORE)}} style={{color:themeColorSet['text-action-primary']}} >Learn More</ThemedText>}
          </ThemedText>
          
        </ThemedView>
        <Button eventName='RENEW_LOAN' additionalProperties={{daysToRenewal}}  label={buttonLabel()} size="MD" type='SOLID' handlePress={handleNavigation}/>
    </ThemedView>
    )
}

export default LoanExpiryCard;